import './style/content.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useEffect } from 'react';
import { useContact } from '../context/ContactContext';

function CTA() {
  const { phone } = useContact();

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);

  const whatsappNumber = phone ? phone.replace(/\D/g, '') : '628132216607';
  const whatsappMessage = encodeURIComponent(
    "Hello EDC Works, I’m interested in collaborating. Can we discuss further?"
  );

  return (
    <section id="cta" className="cta-section">
      <div className="container text-center" data-aos="fade-up">
        <h2 className="cta-title">
          Want to take your brand to the <span className="highlight">next level?</span>
        </h2>
        <p className="cta-subtitle">
          We are open to strategic collaborations that can strengthen your brand identity and visuals.  
          Want to know how we can help your brand? <br />Contact us today.  
          <br /><br />
          <strong>Let’s create something meaningful together.</strong>
        </p>
        <a
          href={`https://wa.me/${whatsappNumber}?text=${whatsappMessage}`}
          target="_blank"
          rel="noopener noreferrer"
          className="cta-button"
        >
          Contact Us on WhatsApp 
        &nbsp;
          <i className='bi bi-whatsapp ml-'> </i>
        </a>
      </div>
    </section>
  );
}

export default CTA;
